// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style-module__dashboard-page--g6UQv{height:100%;display:flex;flex-direction:column;overflow:hidden}`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard/style.module.scss"],"names":[],"mappings":"AAAA,qCACE,WAAA,CACA,YAAA,CACA,qBAAA,CACA,eAAA","sourcesContent":[".dashboard-page {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dashboard-page": `style-module__dashboard-page--g6UQv`
};
export default ___CSS_LOADER_EXPORT___;
